import React from 'react';
import { useNavigate } from 'react-router-dom';

function ParentPortalDashboard() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={handleBack} style={styles.backButton}>← Back to Home</button>
        <h2 style={styles.heading}>Parent Portal Dashboard</h2>
      </div>
      <iframe
        title="Parent Portal Dashboard"
        src="https://lookerstudio.google.com/embed/reporting/3c1c5bf1-60b5-49e3-8af1-caf5e9835402/page/RphPF"
        style={styles.iframe}
        allowFullScreen
      ></iframe>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    height: '100dvh',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  backButton: {
    marginRight: 'auto',
    backgroundColor: '#4285f4',
    color: 'white',
    border: 'none',
    padding: '0.4rem 0.8rem',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  heading: {
    fontSize: '1.1rem',
    margin: 0,
    textAlign: 'center',
    flex: 1,
  },
  iframe: {
    flex: 1,
    width: '100%',
    border: 'none',
  },
};

export default ParentPortalDashboard;
